import service from './service'

class APIList {
  /**
   * @desc 获取数据列表
   */
  constructor() {
    this.prefix = '/manage-event'
  }
  // 设备上下线列表记录
  findDeviceOfflineLog(sn) {
    return service.get(this.prefix + '/alarmEvent/findDeviceOfflineLog?sn=' + sn)
  }
  // 子设备上下线列表记录
  findSubDeviceOfflineLog(sn, sub) {
    return service.get(this.prefix + '/alarmEvent/findSubDeviceOfflineLog?sn=' + sn + "&subDeviceName=" + sub)
  }

  // 查询服务器报警接口
  getServerAllList(params) {
    return service.post(this.prefix + '/server/getAlarms', params)
  }

  getAlarmList1(params) {
    return service.post(this.prefix + '/customAlarm/getAlarms',
      params
    )
  }
  acknowledgeAlarm1(params) {
    return service.post(this.prefix + '/customAlarm/AcknowledgeAlarm',
      params
    )
  }
  purgeAlarm1(params) {
    return service.post(this.prefix + '/customAlarm/purgeAlarm', params)
  }
  getEventList(params) {
    return service.post(this.prefix + '/alarmEvent/getEvents',
      params
    )
  }
  getUsersList() {
    return service.get('/manage-object/project/getOnLineUser')
  }
  forbidden1(params) {
    return service.post(this.prefix + '/customAlarm/disable', params)
  }
  startUsing1(params) {
    return service.post(this.prefix + '/customAlarm/enable', params)
  }
  forbiddenShow1(params) {
    return service.post(this.prefix + '/customAlarm/getDisable', params)
  }
  getAlarmList(params) {
    return service.post(this.prefix + '/alarmEvent/getAlarms',
      params
    )
  }
  acknowledgeAlarm(params) {
    return service.post(this.prefix + '/alarmEvent/AcknowledgeAlarm',
      params
    )
  }
  purgeAlarm(params) {
    return service.post(this.prefix + '/alarmEvent/purgeAlarm', params)
  }
  forbidden(params) {
    return service.post(this.prefix + '/alarmEvent/disable', params)
  }
  startUsing(params) {
    return service.post(this.prefix + '/alarmEvent/enable', params)
  }
  forbiddenShow(params) {
    return service.post(this.prefix + '/alarmEvent/getDisable', params)
  }

  getCustomAlarmList(params) {
    return service.post(this.prefix + '/customAlarm/getAlarms',
      params
    )
  }
}

export default new APIList()



// WEBPACK FOOTER //
// ./src/service/alarmService.js